import Client from './client';

export default class MarketsOrders extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postCancelById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/shopify/markets/orders/${id}/cancel`, {
      ...options,
       method: 'POST',
    });
  }

  postByNumber(organization, number, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/shopify/markets/orders/${number}`, {
      ...options,
       method: 'POST',
    });
  }

  putDestinationByNumber(organization, number, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/shopify/markets/orders/${number}/destination`, {
      ...options,
       method: 'PUT',
    });
  }

  postReplayByNumber(organization, number, options = {}) {
    return this.makeRequest(`${this.host}/internal/${organization}/shopify/markets/orders/${number}/replay`, {
      ...options,
       method: 'POST',
    });
  }

}
